import LockerListContainer from '../../../../Componant/Application/Ecommerce/master/LockerListContainer'

const LockerList = () => {
  return (
    <div className='page-body'>
      <LockerListContainer />
    </div>
  )
}

export default LockerList